import i18n from '@/i18n';

const t = i18n.t.bind(i18n);

/** 列表状态筛选（与后端 status.phase 子串匹配） */
export const MAAS_PHASE_FILTER_OPTIONS = [
  { label: t('cluster:node-status-running'), value: 'Running' },
  { label: t('cluster:pods-status-pending'), value: 'Pending' },
  { label: t('cluster:failed'), value: 'Failed' },
  { label: t('cluster:stopped'), value: 'Stopped' },
  { label: t('cluster:stopping'), value: 'Terminating' },
];
